import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Stack } from '@chakra-ui/react'
import { getNotificationMessage } from 'store'
import { QRCodeCanvas } from 'qrcode.react'
import { StyledButtonContainer } from 'common/Buttons/SingleButton/styled'
import { SUCCEEDED } from 'utils/constants'

export const ShareProfile = ({ id }) => {
  const dispatch = useDispatch()
  const [copyText2, setCopyText2] = useState('Share Profile')
  const [showQR, setShowQR] = useState(0)
  const [qrLink, setQRLink] = useState('')

  const handleQRCode = () => {
    if (showQR === 0) {
      setShowQR(1)

      const profileMarkerLink = process.env.REACT_APP_FRONTEND_URL + '?id=' + id + '&from=qrcode'
      setQRLink(profileMarkerLink)
      navigator.clipboard.writeText(profileMarkerLink)

      dispatch(
        getNotificationMessage({
          type: SUCCEEDED,
          message: 'Saved to Clipboard',
          isEditProfile: true
        })
      )

      const ANIMATION_DURATION = 900
      const scrollStart = Date.now()
      const scrollInterval = setInterval(() => {
        requestAnimationFrame(() => {
          document.querySelector('#bottomBox')?.scrollIntoView({
            behavior: 'auto',
            block: 'end'
          })
        })

        if (Date.now() - scrollStart > ANIMATION_DURATION) {
          clearInterval(scrollInterval)
        }
      }, 0)

      setCopyText2('Close')
    } else {
      setShowQR(0)
      setCopyText2('Share Profile')

      setTimeout(() => setQRLink(''), 800)
    }
  }

  return (
    <Stack
      position="relative"
      paddingTop={showQR ? '190px' : 0}
      transition="0.8s ease"
      display="flex"
      alignItems="center"
    >
      <Stack
        height={showQR ? '190px' : 0}
        width="auto"
        border={showQR ? 'solid 1px black' : 0}
        borderRadius="5px"
        padding={showQR ? '15px' : 0}
        alignItems="center"
        transition="0.8s ease"
        overflow="hidden"
        position="absolute"
        top="-8px"
        left="auto"
        right="auto"
      >
        <QRCodeCanvas value={qrLink} size={160} />
      </Stack>

      <StyledButtonContainer
        id="profile-share-btn"
        style={{ width: '100%' }}
        name="profile-qr-code"
        onClick={() => handleQRCode()}
      >
        {copyText2}
      </StyledButtonContainer>
    </Stack>
  )
}
